import { render, staticRenderFns } from "./EdRubikaDestination.vue?vue&type=template&id=704dde9e&"
import script from "./EdRubikaDestination.vue?vue&type=script&lang=js&"
export * from "./EdRubikaDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports